export const ACTIVE = 'active';
export const CANCELED = 'canceled';
export const COMPLETED = 'completed';

const trainingStatus = [ACTIVE, CANCELED, COMPLETED];

export default trainingStatus;
